import {
  deriveVisibleAdministrationAreas,
  deriveVisibleAdministrationPages,
  type AdministrationAreaId,
  type AdministrationPageId,
} from "@reminder-tracker/domain";

export function AdministrationNavigation({
  activeArea,
  activePage,
  permissions,
}: Readonly<{
  activeArea: AdministrationAreaId;
  activePage: AdministrationPageId;
  permissions: ReadonlyArray<string>;
}>): React.JSX.Element | null {
  const areas = deriveVisibleAdministrationAreas(permissions);
  if (areas.length === 0) return null;
  return (
    <nav aria-label="Administration work areas" className="nav">
      {areas.map((area) => {
        const pages = deriveVisibleAdministrationPages(area.id, permissions);
        const firstPage = pages[0];
        if (firstPage === undefined) return null;
        const selected = area.id === activeArea;
        return (
          <div className="nav-group" key={area.id}>
            <a
              aria-current={selected ? "location" : undefined}
              className="nav-area"
              href={`#${area.id}/${firstPage.id}`}
            >
              <span>{area.label}</span>
              <small>{area.description}</small>
            </a>
            {selected ? (
              <ul className="nav-submenu">
                {pages.map((page) => (
                  <li key={page.id}>
                    <a
                      aria-current={page.id === activePage ? "page" : undefined}
                      href={`#${area.id}/${page.id}`}
                    >
                      {page.label}
                    </a>
                  </li>
                ))}
              </ul>
            ) : null}
          </div>
        );
      })}
    </nav>
  );
}

export function AdministrationMobileHeader({
  open,
  onToggle,
}: Readonly<{ open: boolean; onToggle: () => void }>): React.JSX.Element {
  return (
    <header className="administration-mobile-header">
      <div>
        <strong>Reminder Tracker</strong>
        <span>Site Administration</span>
      </div>
      <button
        type="button"
        className="administration-menu-button"
        aria-controls="administration-navigation"
        aria-expanded={open}
        onClick={onToggle}
      >
        {open ? "Close" : "Menu"}
      </button>
    </header>
  );
}
